export default "/kiban/_next/static/images/ulMark-3e7719caffbfb51ba01dc1592a4cce30.png";